/* rb-d-coll.js -- DESKTOP (>= 768px) collection page. 23 Sep 2026.

   Mark, after the mobile pass: "see if any of the changes we made to mobile
   could be good to apply to desktop" -- then picked the filter-honesty set.
   Three things, all already proven on phones and shared from rb-m-coll.js:

   1. Sizes with nothing in stock are greyed and not selectable
      (collection.metafields.custom.instock_sizes, refreshed nightly by
      rooster-collection-reorder; printed as #rbm-instock-sizes).
   2. When a size filter matches only products the theme then hides as
      sold-out-in-that-size, the grid says why and offers Clear filters,
      instead of a bare "No products found".
   3. The sidebar keeps whichever groups you had open across the re-render
      every tick causes.

   Runs only above 767px (RBM.onDesktop); the mobile modules are no-ops
   there and this is a no-op on phones. Desktop's own Option B filter
   scripts (rb-b-*) are untouched. */
(function () {
  'use strict';
  if (!window.RBM || !RBM.onDesktop) return;

  function shared() { return RBM.collShared || {}; }

  /* 1 -- greyed sizes */
  RBM.onDesktop('d-instock', function () {
    var s = shared(); if (!s.applyInstock) return;
    s.applyInstock();
    setTimeout(s.applyInstock, 600); setTimeout(s.applyInstock, 2000);   /* rb-b regroups the size list late */
  });

  /* 2 -- empty state, repainted after the theme hides its sold-out cards */
  function paintCountDesktop() {
    /* Shopify's "1 product" counts the hidden card; say what is on screen */
    var s = shared(); if (!s.visibleCards) return;
    var all = document.querySelectorAll('.collection-products .product-card').length; if (!all) return;
    var shown = s.visibleCards();
    /* Option B paints its own count as .rbb-count inside .collection__filters-active */
    Array.prototype.forEach.call(document.querySelectorAll('.rbb-count, .collection__filters-active *'), function (el) {
      if (el.children.length) return;
      var m = (el.textContent || '').trim().match(/^([\d,]+)\s+products?$/i); if (!m) return;
      if (!el.dataset.rbdTotal) el.dataset.rbdTotal = m[1];
      el.textContent = (shown < all ? shown + ' of ' + el.dataset.rbdTotal : el.dataset.rbdTotal) + (el.dataset.rbdTotal === '1' && shown === 1 ? ' product' : ' products');
    });
  }
  RBM.onDesktop('d-empty', function () {
    var s = shared(); if (!s.paintEmpty) return;
    var run = function () { s.paintEmpty(); paintCountDesktop(); };
    run(); setTimeout(run, 900); setTimeout(run, 2500);
  });

  /* 3 -- remember open groups across a re-render. `toggle` does not bubble,
     so it is caught in the capture phase at document level. */
  var openState = {}, tracking = false;
  function groupName(g) { var h = g.querySelector('summary'); return (h ? h.textContent : '').trim().toLowerCase(); }
  RBM.onDesktop('d-panelstate', function () {
    var side = document.querySelector('.collection-sidebar'); if (!side) return;
    if (!tracking) {
      tracking = true;
      document.addEventListener('toggle', function (e) {
        var g = e.target && e.target.closest && e.target.closest('.collection-sidebar__filter-group');
        if (g && !RBM.isMobile()) openState[groupName(g)] = !!g.open;
      }, true);
      Array.prototype.forEach.call(side.querySelectorAll('.collection-sidebar__filter-group'), function (g) { openState[groupName(g)] = !!g.open; });
      return;
    }
    Array.prototype.forEach.call(side.querySelectorAll('.collection-sidebar__filter-group'), function (g) {
      var n = groupName(g);
      if (n in openState && g.open !== openState[n]) g.open = openState[n];
    });
  });

  /* 6 -- swatch strip: one row + "+n" so every card is the same height (the
     mobile rule, shared). On desktop the strip is also how a wash is picked
     for quick-add, so "+n" is a button: click it and that card's strip opens
     to every swatch. Re-run late because the count depends on layout. */
  function swatchesDesktop() {
    var s = shared(); if (!s.paintSwatches) return;
    var SEL = '.collection-products .swatch-wrapper, .js-section__featured-collections .swatch-wrapper';
    Array.prototype.forEach.call(document.querySelectorAll('.swatch-wrapper.is-open'), function (w) {
      w.classList.remove('is-open');   /* re-measure from the collapsed state */
    });
    s.paintSwatches(SEL);
    Array.prototype.forEach.call(document.querySelectorAll('.rbm-swatch-more'), function (m) {
      if (m.dataset.rbd) return; m.dataset.rbd = '1';
      m.setAttribute('role', 'button'); m.setAttribute('tabindex', '0');
      m.title = 'Show all colours';
    });
  }
  function openStrip(m) {
    var w = m.closest('.swatch-wrapper'); if (!w) return;
    w.classList.add('is-open');
    Array.prototype.forEach.call(w.querySelectorAll('.product-card__swatch__item'), function (li) { if (li.dataset.rbmHid) li.style.display = ''; });
    m.style.display = 'none';
  }
  /* window-level capture: the theme's card handlers run at document level
     and stop the click before it reaches a listener on the "+n" itself */
  window.addEventListener('click', function (e) {
    if (RBM.isMobile()) return;
    var m = e.target.closest && e.target.closest('.rbm-swatch-more'); if (!m) return;
    e.preventDefault(); e.stopPropagation(); openStrip(m);
  }, true);
  window.addEventListener('keydown', function (e) {
    if (RBM.isMobile() || (e.key !== 'Enter' && e.key !== ' ')) return;
    var m = e.target.closest && e.target.closest('.rbm-swatch-more'); if (!m) return;
    e.preventDefault(); openStrip(m);
  }, true);
  RBM.onDesktop('d-swatches', function () {
    if (!document.querySelector('.collection-products, .js-section__featured-collections')) return;
    swatchesDesktop();
    window.addEventListener('load', function () { setTimeout(swatchesDesktop, 300); });
    setTimeout(swatchesDesktop, 2500);
    window.addEventListener('resize', RBM.debounce(swatchesDesktop, 200), { passive: true });
    /* homepage rail tabs (Just Landed / Denim Fits / Sale) reveal panels that
       measured 0 wide while hidden */
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-section__featured-collections')) setTimeout(swatchesDesktop, 120); });
  });

  RBM.onDesktop('d-rerun', function () {
    var sec = document.querySelector('.shopify-section[id*="product-grid"]') || (document.querySelector('.collection-main') || {}).parentElement;
    if (!sec || !RBM.onSectionSwap) return;
    RBM.onSectionSwap(sec, function () { RBM.rerunDesktop(['d-instock', 'd-empty', 'd-panelstate']); setTimeout(swatchesDesktop, 50); setTimeout(swatchesDesktop, 1500); });
  });
})();
